(() => {
  if (window.neutralsPageTransitionsReady) return;
  window.neutralsPageTransitionsReady = true;
  const eligible = value => {
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && !url.hash && !url.search &&
        /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/(?:$|collections(?:\/|$)|products\/|pages\/|policies\/|blogs\/)/.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  // Browser-managed, bounded prefetch after intent; never fetch cart/account mutations.
  const seen = new Set();
  const intent = event => {
    const connection = navigator.connection;
    if (document.readyState !== 'complete' || window.Shopify?.designMode || connection?.saveData ||
        /(^|-)2g$/.test(connection?.effectiveType || '') || matchMedia('(prefers-reduced-data: reduce)').matches ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || seen.size >= 4) return;
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const url = eligible(anchor.href);
    if (!url || url.href === location.href || seen.has(url.href)) return;
    const link = document.createElement('link');
    if (!link.relList?.supports('prefetch')) return;
    seen.add(url.href); link.rel = 'prefetch'; link.href = url.href; document.head.append(link);
  };
  document.addEventListener('pointerover', intent, {passive:true});
  document.addEventListener('focusin', intent);
})();
